import { merge } from 'lodash';

export const envDefaults = {
  oidc: {
    redirectUri: `${window.location.origin}/implicit/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  },
};

export const npdEnvDefaults = merge(envDefaults, {
  oidc: {
    issuer: 'https://mlbtest.okta.com/oauth2/auswx13p9f2SKsbR91t7',
    clientId: '0oa15m5cjnp6Ku76X1t8',
  },
});
